import { gql } from '@apollo/client/core'
import { reactive } from 'vue'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const salesRestrictions = {
    fetchItemVariationAvailabilitiesAndConstraints: null,
    fetchModifierAvailabilitiesAndConstraints: null,
    itemVariationObservationResponse: null,
    modifierObservationResponse: null
  }

  salesRestrictions.unsubscribe = () => {
    if (!_.isNil(salesRestrictions.itemVariationObservationResponse)) {
      salesRestrictions.itemVariationObservationResponse.unsubscribe()
    }

    if (!_.isNil(salesRestrictions.modifierObservationResponse)) {
      salesRestrictions.modifierObservationResponse.unsubscribe()
    }
  }

  salesRestrictions.subscribe = () => {
    if (!app.config.globalProperties.$cable) return

    salesRestrictions.unsubscribe()

    const itemVariationQuery = gql`subscription {
      itemVariationAvailabilitiesAndConstraintsUpdated {
        data
      }
    }`

    const itemVariationObserver = app.apolloProvider.defaultClient.subscribe({
      query: itemVariationQuery
    })

    salesRestrictions.itemVariationObservationResponse = itemVariationObserver.subscribe({
      next: _.debounce((data) => {
        if (_.isNil(data?.data?.itemVariationAvailabilitiesAndConstraintsUpdated)) return

        salesRestrictions.fetchItemVariationAvailabilitiesAndConstraints?.()
      }, 5000),
      error (error) {
        console.error(error)
      }
    })

    const modifierQuery = gql`subscription {
      modifierAvailabilitiesAndConstraintsUpdated {
        data
      }
    }`

    const modifierObserver = app.apolloProvider.defaultClient.subscribe({
      query: modifierQuery
    })

    salesRestrictions.modifierObservationResponse = modifierObserver.subscribe({
      next: _.debounce((data) => {
        if (_.isNil(data?.data?.modifierAvailabilitiesAndConstraintsUpdated)) return

        salesRestrictions?.fetchModifierAvailabilitiesAndConstraints?.()
      }, 5000),
      error (error) {
        console.error(error)
      }
    })
  }

  function setItemVariationAvailabilitiesAndConstraints (data) {
    console.log('setItemVariationAvailabilitiesAndConstraints', data)
    itemVariations.data = data
  }

  function setModifierAvailabilitiesAndConstraints (data) {
    modifiers.data = data
  }

  const itemVariations = reactive({
    data: null
  })

  const modifiers = reactive({
    data: null
  })

  app.config.globalProperties.$salesRestrictions = salesRestrictions
  app.config.globalProperties.$setItemVariationAvailabilitiesAndConstraints = setItemVariationAvailabilitiesAndConstraints
  app.config.globalProperties.$setModifierAvailabilitiesAndConstraints = setModifierAvailabilitiesAndConstraints
  app.config.globalProperties.$itemVariationAvailabilitiesAndConstraints = itemVariations
  app.config.globalProperties.$modifierAvailabilitiesAndConstraints = modifiers
}
